import { useCallback, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { GET_PROFESSIONAL, GET_PROFESSIONAL_LOGO } from '../../services/graphql/queries/professional';
import { professionalActions } from '../../redux/slices/professionalSlice';
import { useDispatch } from 'react-redux';
import { GetProfessionalType } from '../../services/graphql/queries/types';

export default function useGetProfessional(professionalId: string) {
  const dispatch = useDispatch();
  const { data, loading, refetch } = useQuery<GetProfessionalType>(GET_PROFESSIONAL, {
    variables: {
      id: professionalId
    },
    skip: !professionalId
  });

  const fetchProfessional = useCallback(() => {
    if (data) {
      dispatch(
        professionalActions.setCurrentProfessional(data?.getProfessional)
      );
    }
  }, [data, dispatch]);

  useEffect(() => {
    fetchProfessional();
  }, [fetchProfessional]);

  return {
    data: data?.getProfessional,
    refetch,
    fetchData: fetchProfessional,
    loading
  };
};

export const useGetProfessionalLogo = (variant: 'sm' | 'md' | 'lg') => {
  const dispatch = useDispatch();
  const { data, loading, refetch } = useQuery<{ getProfessionalLogo: string }>(GET_PROFESSIONAL_LOGO, {
    variables: {
      variant
    }
  });

  const fetchProfessionalLogo = useCallback(() => {
    if (data) {
      dispatch(
        professionalActions.setCurrentProfessional(data?.getProfessionalLogo)
      );
    }
  }, [data, dispatch]);

  useEffect(() => {
    fetchProfessionalLogo();
  }, [fetchProfessionalLogo]);

  return {
    data: data?.getProfessionalLogo,
    fetchData: fetchProfessionalLogo,
    refetch,
    loading
  };
};
